import "./nav.scss";
import { useDispatch, useSelector } from "react-redux";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { onLocaleChange } from "redux/actions/Theme";
import { FormattedMessage } from "react-intl";
import { useIntl } from "react-intl";
import { useState, useCallback, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Offcanvas from "react-bootstrap/Offcanvas";
import SearchIcon from "@mui/icons-material/Search";
import { LOCALES } from "lang";
import axios from "axios";
import {
  Dropdown,
  DropdownButton,
  // Form,
  OverlayTrigger,
  Spinner,
  Tooltip,
} from "react-bootstrap";
import {
  SIGNOUT,
  // , SIGNOUT_SUCCESS
} from "redux/constants/Auth";
import { FONT_SIZE_FACTOR } from "constants/GenericConstants";
import {
  getScssRootProperty,
  setScssRootProperty,
} from "functions/scssRootFunction";
import { AsyncTypeahead } from "react-bootstrap-typeahead"; // ES2015
import useSWR from "swr";
import { END_POINTS } from "constants/APIConstant";
import { API_BASE_URL, SEARCH_BASE_URL } from "configs/AppConfig";
import Linkable from "component/LinkableComponent/linkable-component";
import {
  // SEARCH_TYPE_CONST,
  getSearchItemUrl,
} from "functions/SuggesstionsSearchFunction";
import _ from "lodash";
import ReactGA from "react-ga4";

function Nav() {
  const intl = useIntl();
  const navigate = useNavigate();
  const dir = useSelector(({ theme }) => theme.direction);

  ReactGA.initialize(END_POINTS.TRACKING_ID);

  const defaultQueryState = {
    searchTerm: "",
  };

  const [queryFilters, setQueryFilters] = useState(defaultQueryState);
  const [searchTerm, setSearchTerm] = useState("");

  const handleSearch = (searchTerm) => {
    setQueryFilters({ searchTerm: searchTerm });
  };

  // Debounced function to call handleSearch
  const debouncedSearch = useCallback(
    _.debounce((query) => {
      if (query.trim() !== "") {
        handleSearch(query);
      }
    }, 2000),
    []
  );

  useEffect(() => {
    if (searchTerm !== "" && searchTerm !== null) {
      debouncedSearch(searchTerm);
    }
    return () => {
      debouncedSearch.cancel();
    };
  }, [searchTerm, debouncedSearch]);

  const callSearchApi = () => {
    if (
      queryFilters.searchTerm === "" ||
      searchTerm === "" ||
      searchTerm === null ||
      searchTerm.length < 3
    ) {
      return false;
    }
    return true;
  };

  const newsSearchResultsFetching = useSWR(
    callSearchApi()
      ? {
          url: `${SEARCH_BASE_URL}/${END_POINTS.NEWS_SEARCH_TERM}`,
          params: queryFilters,
        }
      : null
  );

  const publicationsSearchResultsFetching = useSWR(
    callSearchApi()
      ? {
          url: `${SEARCH_BASE_URL}/${END_POINTS.PUBLICATIONS_SEARCH_TERM}`,
          params: queryFilters,
        }
      : null
  );

  const indicatorsSearchResultsFetching = useSWR(
    callSearchApi()
      ? {
          url: `${SEARCH_BASE_URL}/${END_POINTS.INDICATORS_SEARCH_TERM}`,
          params: queryFilters,
        }
      : null
  );

  const dispatch = useDispatch();
  const languages = useSelector(({ lookup }) => lookup.lkLanguages);
  // const [singleSelections, setSingleSelections] = useState([]);

  const currentLocale = useSelector(({ theme }) => theme.locale);
  const { fullName, isPaid, subscripitionExpiryDate, id, token } = useSelector(
    ({ auth }) => {
      return auth;
    }
  );
  const isLoggedIn = () => {
    return token && token !== "";
  };
  const renderOptions = () => {
    const defaultOption = { id: 0, title: "", isAdvancedSearch: true };
    const emptyListOption = { id: 0, title: "", isListEmpty: true };
    if (
      (!newsSearchResultsFetching?.data ||
        newsSearchResultsFetching?.isLoading) &&
      (!publicationsSearchResultsFetching?.data ||
        publicationsSearchResultsFetching?.isLoading) &&
      (!indicatorsSearchResultsFetching?.data ||
        indicatorsSearchResultsFetching?.isLoading)
      //searchResultsFetching.error
    ) {
      return [defaultOption];
    }

    if (
      newsSearchResultsFetching?.data?.data?.length > 0 ||
      publicationsSearchResultsFetching?.data?.data?.length > 0 ||
      indicatorsSearchResultsFetching?.data?.data?.length > 0
    ) {
      var result = [];
      if (newsSearchResultsFetching?.data?.data?.length > 0) {
        result.push(...newsSearchResultsFetching?.data?.data?.slice(0, 5));
      }
      if (publicationsSearchResultsFetching?.data?.data?.length > 0) {
        result.push(
          ...publicationsSearchResultsFetching?.data?.data?.slice(0, 5)
        );
      }
      if (indicatorsSearchResultsFetching?.data?.data?.length > 0) {
        result.push(
          ...indicatorsSearchResultsFetching?.data?.data?.slice(0, 5)
        );
      }

      result.push(defaultOption);
      return result;
    }
    return [(emptyListOption, defaultOption)];
  };

  function onInputSearch(query) {
    setSearchTerm(query);
  }

  function onSearch(query) {
    //console.log("Search Here: ", query);
    setQueryFilters({ searchTerm: query });
  }

  const fontSizeFactorNumber = () => {
    const getCurrentSizeFactor = getScssRootProperty({
      rootName: "--font-size-factor",
    });
    const filteringCurrentSizeFactor = getCurrentSizeFactor.replaceAll(
      "px",
      ""
    );
    const sizeFactorToInt = parseInt(filteringCurrentSizeFactor);
    return sizeFactorToInt;
  };
  const onIncrementFontSize = () => {
    const currentSizeFactor = fontSizeFactorNumber();

    if (currentSizeFactor < 2) {
      const newFontFactorSize =
        (FONT_SIZE_FACTOR.INCREMENT + currentSizeFactor).toString() + "px";
      setScssRootProperty({
        rootName: "--font-size-factor",
        value: newFontFactorSize,
      });
    }
  };

  const onDecrementFontSize = () => {
    const currentSizeFactor = fontSizeFactorNumber();

    if (currentSizeFactor > -2) {
      const newFontFactorSize =
        (FONT_SIZE_FACTOR.DECREMENT + currentSizeFactor).toString() + "px";
      setScssRootProperty({
        rootName: "--font-size-factor",
        value: newFontFactorSize,
      });
    }
  };

  const onDefaultFontSize = () => {
    const currentSizeFactor = fontSizeFactorNumber();

    if (currentSizeFactor !== 0) {
      setScssRootProperty({
        rootName: "--font-size-factor",
        value: "0px",
      });
    }
  };
  const onLangClick = (e) => {
    const getSwitchLangDetails = languages.filter(
      (att) => att.locale !== currentLocale
    )[0];
    dispatch(
      onLocaleChange({
        locale: getSwitchLangDetails.locale,
        direction: getSwitchLangDetails.direction,
      })
    );
  };
  const listOfLinks = [
    {
      path: "new",
      title: "the-new",
    },
    {
      path: "data",
      title: "data",
    },
    {
      path: "publications",
      title: "publications",
    },
    {
      path: "servicestools",
      title: "service-tools",
    },
    {
      path: "mediaLanding",
      title: "media-center",
    },
    {
      path: "about",
      title: "about-capmas",
    },
    {
      path: "contact",
      title: "contact-us",
    },
  ];

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  function calculateWindowWidth() {
    return window.innerWidth;
  }

  const [windowWidth, setWindowWidth] = useState(false);
  window.addEventListener("resize", () => {
    if (calculateWindowWidth() > 991.99) {
      handleClose();
    }
    if (calculateWindowWidth() < 400.01) {
      setWindowWidth(true);
    }
    if (calculateWindowWidth() > 400.01) {
      setWindowWidth(false);
    }
  });

  const resizePage = () => {
    if (calculateWindowWidth() > 991.99) {
      handleClose();
    }
    if (calculateWindowWidth() < 400.01) {
      setWindowWidth(true);
    }
    if (calculateWindowWidth() > 400.01) {
      setWindowWidth(false);
    }
  };

  useEffect(() => {
    let timeOut = setTimeout(() => {
      resizePage();
    }, 0);
    return () => {
      clearTimeout(timeOut);
    };
  }, [calculateWindowWidth()]);

  const signOutHandler = async () => {
    try {
      const headers = {
        Authorization: `bearer ${token}`,
      };
      let result = await axios.post(
        `${API_BASE_URL}/${END_POINTS.API_LOGOUT}`,
        null,
        {
          headers: headers,
        }
      );
      if (result.status === 200) {
        dispatch({ type: SIGNOUT });
        localStorage.removeItem("passwordUserCapmas");
        localStorage.removeItem("cachedPopulation");
        ReactGA.set({
          userId: null,
          userName: null,
        });
      }
    } catch (error) {
      console.log(error);
      dispatch({ type: SIGNOUT });
      localStorage.removeItem("passwordUserCapmas");
      localStorage.removeItem("cachedPopulation");
      ReactGA.set({
        userId: null,
        userName: null,
      });
    }
  };

  return (
    <>
      <div className="nav-responsive fixed-top bg-white shadow">
        <NavLink to="/" className="logo-responsive">
          <img
            src={process.env.PUBLIC_URL + "/image/logo.png"}
            alt="logo"
            loading="lazy"
          />
        </NavLink>
        <div className="nav-top__login">
          {/* <div className="lang">
            
          </div> */}
          {isLoggedIn() ? (
            <div className="container-loggedin" title={fullName}>
              <DropdownButton
                id={`dropdown-profile`}
                className={`login-btn ${
                  isPaid
                    ? subscripitionExpiryDate
                      ? subscripitionExpiryDate?.slice(0, 10) >
                        new Date().toJSON().slice(0, 10)
                        ? "isPaid"
                        : "isntPaid"
                      : "isntPaid"
                    : ""
                }`}
                style={{ borderRadius: "30px" }}
                title={
                  fullName?.length > 15
                    ? !windowWidth
                      ? fullName.slice(0, 15)
                      : fullName.slice(0, 5)
                    : !windowWidth
                    ? fullName
                    : fullName.slice(0, 5)
                }
              >
                <Dropdown.Item
                  title=""
                  className={`px-0 ${
                    dir === "rtl" ? "text-end" : "text-start"
                  }`}
                >
                  <Link to={"profile"} className="text-black d-block px-3">
                    <FormattedMessage id="profile" />
                  </Link>
                </Dropdown.Item>
                <Dropdown.Item
                  title=""
                  className={`px-0 ${
                    dir === "rtl" ? "text-end" : "text-start"
                  }`}
                >
                  <Link
                    to={`../resetPass/${id}`}
                    className="text-black d-block px-3"
                  >
                    <FormattedMessage id="resetPass" />
                  </Link>
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={signOutHandler}
                  title=""
                  className={`${dir === "rtl" ? "text-end" : "text-start"}`}
                >
                  <FormattedMessage id="sign-out" />
                </Dropdown.Item>
              </DropdownButton>
              {isPaid && subscripitionExpiryDate && (
                <span
                  className={`ispaid start-50 translate-middle-x ${
                    subscripitionExpiryDate?.slice(0, 10) >
                    new Date().toJSON().slice(0, 10)
                      ? "second-color"
                      : "text-black"
                  }`}
                >
                  {subscripitionExpiryDate?.slice(0, 10) >
                  new Date().toJSON().slice(0, 10) ? (
                    <FormattedMessage id="expires-in" />
                  ) : (
                    <FormattedMessage id="expired-in" />
                  )}{" "}
                  {subscripitionExpiryDate?.slice(0, 10)}
                </span>
              )}
            </div>
          ) : (
            <Link to={"login"} className="login-btn as-link">
              <img
                src={process.env.PUBLIC_URL + "/image/login.svg"}
                alt="login"
                loading="lazy"
              />
              <span>
                &nbsp;&nbsp;
                <FormattedMessage id="login" />
              </span>
            </Link>
          )}
          <Button className="lang-btn" onClick={onLangClick}>
            <img
              src={process.env.PUBLIC_URL + "/image/lang.svg"}
              alt="lang"
              loading="lazy"
            />
            <span>
              {currentLocale === LOCALES.ARABIC
                ? LOCALES.ENGLISH.toUpperCase()
                : LOCALES.ARABIC.toUpperCase()}
            </span>
          </Button>
          <Button
            variant="outline"
            className="font-size-btn"
            onClick={onIncrementFontSize}
          >
            <img
              width={27}
              height={27}
              src={
                process.env.PUBLIC_URL + "/image/font-size-increment-img.png"
              }
              alt="lang-icon"
              loading="lazy"
            />
          </Button>
          <Button
            variant="outline"
            className="font-size-btn"
            onClick={onDefaultFontSize}
          >
            <img
              width={22}
              height={22}
              src={process.env.PUBLIC_URL + "/image/font-size-default-img.png"}
              alt="lang-icon"
              loading="lazy"
            />
          </Button>
          <Button
            variant="outline"
            className="font-size-btn"
            onClick={onDecrementFontSize}
          >
            <img
              width={18}
              height={18}
              src={
                process.env.PUBLIC_URL + "/image/font-size-decrement-img.png"
              }
              alt="lang-icon"
              loading="lazy"
            />
          </Button>
        </div>

        <Button
          variant="primary"
          className="button-drawer-nav"
          onClick={handleShow}
        >
          <div className="bar border-0">
            <i className="fa fa-bars"></i>
          </div>
        </Button>

        <Offcanvas show={show} onHide={handleClose}>
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>
              <img
                src={process.env.PUBLIC_URL + "/image/logo.png"}
                alt="logo"
                loading="lazy"
                className="w-75"
              />
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <div className="search-bar">
              <AsyncTypeahead
                isLoading={false}
                id="basic-typeahead-single"
                labelKey={(option) => {
                  return option.title;
                }}
                filterBy={(option) => {
                  return option.id.toString();
                }}
                options={renderOptions()}
                onSearch={onSearch}
                useCache={false}
                onInputChange={onInputSearch}
                placeholder={intl.formatMessage({ id: "search" })}
                emptyLabel={intl.formatMessage({ id: "data-not-found" })}
                renderMenuItemChildren={(option) => {
                  // if (option.isAdvancedSearch) {
                  //   return (
                  //     <>
                  //       <div
                  //         className="dropdown-divider"
                  //         role="separator"
                  //         style={{ cursor: "pointer" }}
                  //         onClick={() =>
                  //           navigate("advanced-search", {
                  //             state: { currentSearch: searchTerm },
                  //           })
                  //         }
                  //       ></div>
                  //       <div className="advanced-search-item">
                  //         <FormattedMessage id="advanced-search" />
                  //       </div>
                  //     </>
                  //   );
                  // }
                  if (option.isListEmpty) {
                    return (
                      <div className="data-not-found-item">
                        <FormattedMessage id="data-not-found" />
                      </div>
                    );
                  }
                  return (
                    <Linkable link={getSearchItemUrl(option)}>
                      <OverlayTrigger
                        delay={{ hide: 450, show: 300 }}
                        overlay={(props) => (
                          <Tooltip {...props}>{option.title}</Tooltip>
                        )}
                      >
                        <div className="search-item">{option.title}</div>
                      </OverlayTrigger>
                    </Linkable>
                  );
                }}
              />
              <div
                className="suffix-component"
                style={{
                  right: dir === "rtl" ? "auto" : "5px",
                  left: dir === "rtl" ? "5px" : "auto",
                }}
              >
                {newsSearchResultsFetching.isLoading &&
                queryFilters.searchTerm !== "" &&
                queryFilters.searchTerm !== null ? (
                  <Spinner
                    animation="border"
                    style={{
                      width: "22px",
                      height: "22px",
                    }}
                  />
                ) : (
                  <SearchIcon
                    titleAccess={intl.formatMessage({ id: "advanced-search" })}
                    onClick={() =>
                      navigate("advanced-search", {
                        state: { currentSearch: searchTerm },
                      })
                    }
                    style={{
                      right: dir === "rtl" ? "auto" : "5px",
                      left: dir === "rtl" ? "5px" : "auto",
                      cursor: "pointer",
                    }}
                  />
                )}
              </div>
            </div>
            <ul className="mt-3">
              {listOfLinks.map(({ path, title }, i) => (
                <li key={i}>
                  <NavLink to={`/${path}`} onClick={handleClose}>
                    <FormattedMessage id={title} />
                  </NavLink>
                </li>
              ))}
            </ul>
          </Offcanvas.Body>
        </Offcanvas>
      </div>

      <nav className="fixed-top bg-white not-pagination">
        <div className="container">
          <div className="nav-top">
            <NavLink to="/" className="logo">
              <img
                src={process.env.PUBLIC_URL + "/image/logo.png"}
                alt="logo"
                loading="lazy"
              />
            </NavLink>
            <div className="nav-top__login">
              {/* <DropdownButton
                id={`dropdown-profile`}
                className="dropdown-button"
                title={getDropDownTitle()}
              >
                <RenderLanguages />
              </DropdownButton> */}

              {isLoggedIn() ? (
                <div className="container-loggedin" title={fullName}>
                  <DropdownButton
                    id={`dropdown-profile`}
                    className={`login-btn ${
                      isPaid
                        ? subscripitionExpiryDate
                          ? subscripitionExpiryDate?.slice(0, 10) >
                            new Date().toJSON().slice(0, 10)
                            ? "isPaid"
                            : "isntPaid"
                          : "isntPaid"
                        : ""
                    }`}
                    style={{ borderRadius: "30px" }}
                    title={
                      fullName?.length > 15 ? fullName.slice(0, 15) : fullName
                    }
                  >
                    <Dropdown.Item
                      title=""
                      className={`px-0 ${
                        dir === "rtl" ? "text-end" : "text-start"
                      }`}
                    >
                      <Link to={"profile"} className="text-black d-block px-3">
                        <FormattedMessage id="profile" />
                      </Link>
                    </Dropdown.Item>
                    <Dropdown.Item
                      title=""
                      className={`px-0 ${
                        dir === "rtl" ? "text-end" : "text-start"
                      }`}
                    >
                      <Link
                        to={`../resetPass/${id}`}
                        className="text-black d-block px-3"
                      >
                        <FormattedMessage id="resetPass" />
                      </Link>
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={signOutHandler}
                      title=""
                      className={`${dir === "rtl" ? "text-end" : "text-start"}`}
                    >
                      <FormattedMessage id="sign-out" />
                    </Dropdown.Item>
                  </DropdownButton>
                  {isPaid && subscripitionExpiryDate && (
                    <span
                      className={`ispaid start-50 translate-middle-x ${
                        subscripitionExpiryDate?.slice(0, 10) >
                        new Date().toJSON().slice(0, 10)
                          ? "second-color"
                          : "text-black"
                      }`}
                    >
                      {subscripitionExpiryDate?.slice(0, 10) >
                      new Date().toJSON().slice(0, 10) ? (
                        <FormattedMessage id="expires-in" />
                      ) : (
                        <FormattedMessage id="expired-in" />
                      )}{" "}
                      {subscripitionExpiryDate?.slice(0, 10)}
                    </span>
                  )}
                </div>
              ) : (
                <Link to={"login"} className="login-btn">
                  <img
                    src={process.env.PUBLIC_URL + "/image/login.svg"}
                    alt="login"
                    loading="lazy"
                  />
                  <span className="mx-auto">
                    <FormattedMessage id="login" />
                  </span>
                </Link>
              )}
              <Button className="lang-btn" onClick={onLangClick}>
                <img
                  src={process.env.PUBLIC_URL + "/image/lang.svg"}
                  alt="lang-icon"
                  loading="lazy"
                />
                <span>
                  {currentLocale === LOCALES.ARABIC
                    ? LOCALES.ENGLISH.toUpperCase()
                    : LOCALES.ARABIC.toUpperCase()}
                </span>
              </Button>
              <Button
                variant="outline"
                className="font-size-btn"
                onClick={onIncrementFontSize}
              >
                <img
                  width={30}
                  height={30}
                  src={
                    process.env.PUBLIC_URL +
                    "/image/font-size-increment-img.png"
                  }
                  alt="lang-icon"
                  loading="lazy"
                />
              </Button>
              <Button
                variant="outline"
                className="font-size-btn"
                onClick={onDefaultFontSize}
              >
                <img
                  width={25}
                  height={25}
                  src={
                    process.env.PUBLIC_URL + "/image/font-size-default-img.png"
                  }
                  alt="lang-icon"
                  loading="lazy"
                />
              </Button>
              <Button
                variant="outline"
                className="font-size-btn"
                onClick={onDecrementFontSize}
              >
                <img
                  width={20}
                  height={20}
                  src={
                    process.env.PUBLIC_URL +
                    "/image/font-size-decrement-img.png"
                  }
                  alt="lang-icon"
                  loading="lazy"
                />
              </Button>
            </div>
          </div>
        </div>

        <div className="nav-links">
          <div className="container d-flex justify-content-between align-items-center">
            <ul>
              {listOfLinks.map(({ path, title }, i) => (
                <li key={i}>
                  <NavLink to={`/${path}`}>
                    <FormattedMessage id={title} />
                  </NavLink>
                </li>
              ))}
            </ul>

            <div className="search-bar">
              <AsyncTypeahead
                isLoading={false}
                id="basic-typeahead-single"
                labelKey={(option) => {
                  return option.title;
                }}
                filterBy={(option) => {
                  return option.id.toString();
                }}
                options={renderOptions()}
                onSearch={onSearch}
                useCache={false}
                onInputChange={onInputSearch}
                placeholder={intl.formatMessage({ id: "search" })}
                emptyLabel={intl.formatMessage({ id: "data-not-found" })}
                renderMenuItemChildren={(option) => {
                  // if (option.isAdvancedSearch) {
                  //   return (
                  //     <Linkable link={"advanced-search"}>
                  //       <div
                  //         className="dropdown-divider"
                  //         role="separator"
                  //       ></div>
                  //       <div className="advanced-search-item">
                  //         <FormattedMessage id="advanced-search" />
                  //       </div>
                  //     </Linkable>
                  //   );
                  // }
                  if (option.isListEmpty) {
                    return (
                      <div className="data-not-found-item">
                        <FormattedMessage id="data-not-found" />
                      </div>
                    );
                  }
                  return (
                    <Linkable link={getSearchItemUrl(option)}>
                      <OverlayTrigger
                        delay={{ hide: 450, show: 300 }}
                        overlay={(props) => (
                          <Tooltip {...props}>{option.title}</Tooltip>
                        )}
                      >
                        <div className="search-item">{option.title}</div>
                      </OverlayTrigger>
                    </Linkable>
                  );
                }}
              />
              <div
                className="suffix-component"
                style={{
                  right: dir === "rtl" ? "auto" : "5px",
                  left: dir === "rtl" ? "5px" : "auto",
                }}
              >
                {newsSearchResultsFetching.isLoading &&
                queryFilters.searchTerm !== "" &&
                queryFilters.searchTerm !== null ? (
                  <Spinner
                    animation="border"
                    style={{
                      width: "22px",
                      height: "22px",
                    }}
                  />
                ) : (
                  <SearchIcon
                    titleAccess={intl.formatMessage({ id: "advanced-search" })}
                    onClick={() =>
                      navigate("advanced-search", {
                        state: { currentSearch: searchTerm },
                      })
                    }
                    style={{
                      right: dir === "rtl" ? "auto" : "5px",
                      left: dir === "rtl" ? "5px" : "auto",
                      cursor: "pointer",
                    }}
                  />
                  // <Tooltip
                  //   style={{
                  //     right: dir === "rtl" ? "auto" : "5px",
                  //     left: dir === "rtl" ? "5px" : "auto",
                  //   }}
                  //   title="Advanced Search"
                  // >
                  //   <IconButton>
                  //     <SearchIcon />
                  //   </IconButton>
                  // </Tooltip>
                )}
              </div>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
}

export default Nav;
